export const en = {
    consent: {
        titulo: "Cookie consent",
        texto: "We use cookies to measure visits and improve event communication. Marketing measurement is only activated with your consent.",
        aceitar: "Accept",
        rejeitar: "Essential only",
        saberMais: "Learn more",
    },
    nav: {
        experiencia: "Experience",
        noiteFados: "Fado Night",
        equipa: "Team",
        artistas: "Artists",
        noticias: "News",
        missao: "Mission",
        associacao: "The Association",
        vantagens: "Member Benefits",
        contacto: "Contact",
        reservar: "Book",
        local: "Getting Here",
    },
    hero: {
        headlineTop: "A NIGHT\nDEDICATED TO",
        headlineAdj: "PORTUGUESE",
        headlineItalico: "A portuguese night.\nAt the table.\nLive.",
        quando: "When",
        data: "14 November 2026",
        hora: "from 5:00 pm",
        onde: "Where",
        local: "Centro Papa Giovanni",
        morada: "Hübelistrasse 55, Emmenbrücke",
        comprar: "Buy Tickets",
        urgencia: "Exclusive event · Limited seats",
        saibaMais: "Learn More",
        countdown: {
            label: "Early Bird price ends in",
            dias: "days",
            horas: "hours",
            min: "min",
            seg: "sec",
        },
    },
    pillars: [
        { id: "fado-ao-vivo", title: "Live Fado", text: "The emotion of Fado, Portugal's intangible heritage." },
        { id: "gastronomia", title: "Portuguese Gastronomy", text: "Traditional flavours in a dinner prepared with excellence." },
        { id: "vinhos", title: "Portuguese Wines", text: "A selection of wines from Portugal's finest regions." },
        { id: "cultura", title: "Culture & Tradition", text: "A celebration of our identity, history and hospitality." },
        { id: "ambiente", title: "Exclusive Atmosphere", text: "An intimate space for an unforgettable experience." },
    ],
    watermark: "Visual Example",
    influencer: {
        label: "Official Influencer",
        nome: "Nelson Jackson",
        titulo: "The voice bringing Fados à Mesa to the community",
        texto: "Nelson Jackson is the official influencer of Fados à Mesa. Flag on his shoulders and his usual energy, he will join us in the countdown to the night of 14 November — behind the scenes, news and surprises on social media.",
        legenda: "Nelson Jackson's message to the Portuguese community",
        play: "Watch the video",
    },
    convidadoHonra: {
        label: "Guest of Honour",
        confirmado: "Attendance confirmed",
        bemVindo: "Welcome, Your Excellency!",
        excelencia: "His Excellency",
        nome: "Dr. Gonçalo Motta",
        cargo: "Consul General of Portugal in Zurich",
        citacao: "Culture brings us closer. Portugal lives in each one of us.",
        texto: "It is with great honour that we welcome His Excellency Dr. Gonçalo Motta, Consul General of Portugal in Zurich, as our guest of honour at Fados à Mesa. The presence of Portugal's diplomatic representation is a recognition of the value of Portuguese culture and of the importance of keeping our traditions alive, uniting the community around music, gastronomy and our identity.",
        sobreTitulo: "About Dr. Gonçalo Motta",
        sobre: "Dr. Gonçalo Motta is the current Consul General of Portugal in Zurich, representing Portugal's Ministry of Foreign Affairs. Educated at Universidade Lusíada in Lisbon and with extensive diplomatic experience, he is dedicated to strengthening relations between Portugal and Switzerland, supporting the Portuguese communities and promoting Portugal's culture and image abroad.",
        verCartaz: "View the official poster",
    },
    patrocinadores: {
        titulo: "OFFICIAL SPONSORS",
        maisA: "And more",
        maisB: "Sponsors",
        agradecimentos: {
            famosa: "Our deepest thanks to Pastelaria Famosa, our Exclusive Sponsor, for the trust and the sweetness with which it has embraced this night from day one.",
            srVinho: "Thank you to Sr. Vinho, the traditional restaurant welcoming our members with a 10% discount and a complimentary digestif.",
            cr7Helder: "Our heartfelt thanks to CR7 Helder, for believing in Fado and driving us, in style, to this night.",
            saboresPortugal: "Our heartfelt thanks to Sabores de Portugal, for bringing the best of our gastronomy to the table and giving this night a true taste of Portugal.",
            wildenMann: "Thank you to Hotel Wilden Mann, five centuries of Lucerne hospitality standing beside Fado.",
            barniPost: "Thank you to Barni-Post, for bringing Fado into every home in Central Switzerland.",
            superBock: "Thank you to Super Bock Group, for bringing the most Portuguese of beers to the table.",
            clubPortugues: "Thank you to Club Português Luzern, home of our community for so many years.",
            casaBenfica: "Thank you to Casa Benfica Zurique, for the passion that unites Portuguese people across Switzerland.",
            immoHaus: "Thank you to ImmoHaus Portugal, for helping so many families find a home — and for opening theirs to us.",
        },
    },
    artistas: { titulo: "OUR ARTISTS" },
    parceiros: { titulo: "INSTITUTIONAL PARTNERS" },
    localizacao: {
        saberMais: "Learn More",
        label: "Where the event takes place",
        titulo: "HOW TO GET HERE",
        intro: "The event takes place in Emmenbrücke, reachable by public transport, car or bicycle. Below you will find the practical travel information.",
        moradaLabel: "Address",
        moradaValor: "Centro Papa Giovanni, Hübelistrasse 55, 6020 Emmenbrücke, Switzerland",
        gpsLabel: "GPS Coordinates",
        gpsValor: "47.0706° N, 8.2849° E",
        acessosTitulo: "Access",
        transportesTitulo: "Public Transport",
        transportes: "Emmenbrücke Gersag station about a 10-minute walk (regional trains and buses 41, 42, 43 and 44). From Lucerne, VBL line 2; night bus N2 for the return.",
        carroTitulo: "Car",
        carro: "5 minutes from the A2 motorway (Emmen Nord exit).",
        bicicletaTitulo: "Bicycle",
        bicicleta: "Bicycle parking available on site.",
        estacionamentoTitulo: "Free Parking",
        estacionamento: "Free Häger car park right across — only spaces marked «Häger», subject to availability. More car parks nearby, free and paid.",
        regrasTitulo: "Centro Papa Giovanni House Rules",
        regras: [
            "Pets are not allowed to enter or stay on the premises.",
            "Smoking is prohibited throughout the building's indoor areas.",
        ],
    },
    cta: {
        comprar: "Buy Tickets",
        urgencia: "Exclusive event · Limited seats",
        titulo: "BOOK YOUR SEAT NOW.",
        subtitulo: "One night. One table. One Fado.",
    },
    culturaNoticias: {
        noticias: "LATEST NEWS",
        nota: "Sample news — updates about the event will appear here.",
        news: [
            { title: "Fados à Mesa launches its first edition on 14 November 2026", date: "15 MAY 2025" },
            { title: "Meet the artists who bring Fado to life on stage", date: "10 MAY 2025" },
            { title: "Flavours of Portugal: the dinner that celebrates our tradition", date: "05 MAY 2025" },
        ],
    },
    footer: {
        frase: "A Portuguese night, most certainly.",
        copyright: "© 2026 Fados à Mesa – All rights reserved.",
        sede: "Fados à Mesa Association · UID CHE-306.330.271 · Gerliswilstrasse 46, 6020 Emmenbrücke, Switzerland",
        privacy: "Privacy Policy",
        terms: "Terms & Conditions",
        colunas: [
            {
                title: "Fado Night",
                links: [
                    { label: "Event Menu", to: "/experiencia?tab=menu" },
                    { label: "Culture & Tradition", to: "/experiencia?tab=cultura" },
                    { label: "Gastronomy & Wines", to: "/experiencia?tab=gastro" },
                    { label: "Bar", to: "/experiencia?tab=bar" },
                    { label: "Team", to: "/equipa", ate1aEdicao: true },
                ],
            },
            {
                title: "Artists",
                links: [
                    { label: "Artists", to: "/#artistas" },
                    { label: "News", to: "/noticias" },
                ],
            },
            {
                title: "The Association",
                links: [
                    { label: "Mission", to: "/missao" },
                    { label: "Member Benefits", to: "/socios/vantagens" },
                    { label: "Become a Member", to: "/associacao#adesao" },
                    { label: "Sponsors", to: "/patrocinadores" },
                ],
            },
            {
                title: "Tickets",
                links: [
                    { label: "Buy Tickets", to: "/bilhetes" },
                    { label: "Confirm Attendance", to: "/confirmar" },
                ],
            },
            {
                title: "Contact",
                links: [
                    { label: "Contact Us", to: "/contacto" },
                    { label: "Getting Here", to: "/local" },
                    { label: "Resource Center", to: "/recursos" },
                ],
            },
        ],
    },
    subpage: { voltar: "Back" },
    audio: { tocar: "Play music", pausar: "Pause music" },
    bc: {
        home: "Home",
        experiencia: "Experience",
        equipa: "Team",
        artistas: "Artists",
        noticias: "News",
        missao: "Mission",
        contacto: "Contact",
        local: "Location",
        confirmar: "Confirmation",
        bilhetes: "Ticket Office",
        privacidade: "Privacy Policy",
        termos: "Terms & Conditions",
        recursos: "Resource Center",
        patrocinadores: "Sponsors",
    },
    seo: {
        keywords: "Fado, Fados à Mesa, Portuguese culture, Portuguese gastronomy, Portuguese wines, Portuguese event Switzerland, Fado Lucerne, Emmenbrücke, dinner show, Ticket Corner",
        home: { title: "Fados à Mesa — Fado, Gastronomy and Portuguese Wines in Switzerland", desc: "A dinner-show with live Fado, Portuguese gastronomy and wines. 14 November 2026, Centro Papa Giovanni, Emmenbrücke. Book your ticket." },
        experiencia: { title: "The Experience — Menu, Line-up and Fado Etiquette | Fados à Mesa", desc: "Discover the official menu, the night's line-up and Fado etiquette: a Portuguese night served at the table, between traditional dishes and live Fado." },
        equipa: { title: "Our Team — Production & Staff | Fados à Mesa", desc: "Meet the team who makes the night happen: executive and artistic production, kitchen and floor of Fados à Mesa's 1st edition." },
        missao: { title: "The Mission — Portuguese Culture in Switzerland | Fados à Mesa", desc: "Bringing Portuguese culture to Switzerland — one night, one table and one guitar at a time. Culture, table and encounter: the values of Fados à Mesa." },
        contacto: { title: "Contact — Write to Us | Fados à Mesa", desc: "Contact the Fados à Mesa event: group bookings, partnerships and sponsorships, press and questions about the 1st edition." },
        local: { title: "Getting Here — Centro Papa Giovanni, Emmenbrücke | Fados à Mesa", desc: "How to reach Centro Papa Giovanni (Hübelistrasse 55, Emmenbrücke): public transport, car, Uber and bicycle. Free parking nearby." },
        noticias: { title: "News — Fado, Portuguese Culture and Updates | Fados à Mesa", desc: "Official Fados à Mesa announcements and selected news about our artists: Rafael Pacheco, Ginestal Martins, Cátia Garcia, Daniel Pinto Coelho and Madalena Gil." },
        confirmar: { title: "Confirm Attendance — Choose Your Main Course | Fados à Mesa", desc: "Confirm your attendance at Fados à Mesa and choose your main course (fish or meat) by 1 November 2026." },
        bilhetes: { title: "Official Ticket Office — Buy Tickets | Fados à Mesa", desc: "Buy your ticket for Fados à Mesa at the official ticket office (Eventim / Ticket Corner). Exclusive event, limited seats. 14.11.2026, Emmenbrücke." },
        privacidade: { title: "Privacy Policy | Fados à Mesa", desc: "Fados à Mesa privacy policy — personal data processing in accordance with Swiss law (nFADP)." },
        associacao: { title: "The Association | Fados à Mesa", desc: "The Fados à Mesa Association: who we are, institutional details, board, partners, fees, membership application and statutes." },
        termos: { title: "Terms & Conditions | Fados à Mesa", desc: "Terms and conditions of the Fados à Mesa website and event." },
        recursos: { title: "Resource Center — Press and Partners | Fados à Mesa", desc: "Official Fados à Mesa materials for press and partners: project book, press kit, logos and the night's programme." },
        patrocinadores: { title: "Official Sponsors | Fados à Mesa", desc: "The official partners of Fados à Mesa — a Portuguese night in Switzerland." },
    },
    assoc: {
        titulo: "THE ASSOCIATION",
        intro: "A non-profit association, politically neutral and confessionally independent, constituted in Emmen on 25 September 2026.",
        subnav: { quemSomos: "Who We Are", dados: "Details", direcao: "Board", parceiros: "Partners", quotas: "Fees", adesao: "Membership", estatutos: "Statutes" },
        quemSomos: {
            titulo: "WHO WE ARE",
            p1: "The Fados à Mesa Association is a non-profit association, politically neutral and confessionally independent, with its registered office in Emmen, Canton of Lucerne. Its purpose is to promote, preserve and disseminate Portuguese and Lusophone culture in Switzerland, in particular fado, music, gastronomy, the Portuguese language and traditions.",
            p2: "To this end, we organize cultural, musical, gastronomic, educational and social events, our main project being the «Fados à Mesa» event. We promote cultural exchange between the Lusophone community and the Swiss population, support artists and creators of Portuguese expression, and cooperate with municipalities, cantons, foundations, companies, cultural institutions and other associations.",
            p3: "Our activities are open to the general public. The association does not pursue profit: any surpluses are allocated in full to the statutory purposes and are never distributed to members.",
        },
        dados: {
            titulo: "INSTITUTIONAL DETAILS",
            denominacao: "Name", formaJuridica: "Legal form", sede: "Registered office", morada: "Address",
            constituicao: "Date of constitution", duracao: "Duration", uid: "UID number", conta: "Bank account",
            exercicio: "Financial year", contacto: "Contact",
            denominacaoV: "Associação Fados à Mesa (Verein Fados à Mesa)",
            formaJuridicaV: "Non-profit association, art. 60 et seq. SCC",
            sedeV: "Municipality of Emmen, Canton of Lucerne, Switzerland",
            moradaV: "Gerliswilstrasse 46, 6020 Emmenbrücke",
            constituicaoV: "25.09.2026 (Founding Assembly, Minute no. 1)",
            duracaoV: "Indefinite",
            emTratamento: "In progress", aDesignar: "To be assigned",
            exercicioV: "Calendar year",
        },
        direcao: {
            titulo: "BOARD AND FOUNDING MEMBERS",
            comite: "Executive Committee", mandato: "Term 2026–2028",
            fundadores: "Founding members with roles on event days",
            nota: "The President, the Vice-President, the Logistics Director and the Technical Director are the four founding members of the association.",
            paulaAngelinoNota: "Also takes on the artistic direction, marketing, design and communication.",
            cristinaNota: "Assumes all executive powers in the event of the President's impediment.",
            paulaSilvaNota: "Management of logistics and teams on event days.",
            pauloNota: "Technical coordination of events.",
            cargoPaulaAngelino: "President and Executive Director",
            cargoCristina: "Vice-President",
            cargoPaulaSilva: "Founding member and Logistics Director",
            cargoPaulo: "Founding member and Technical Director",
        },
        parceiros: {
            titulo: "PARTNERS AND SPONSORS",
            intro: "Institutions and partners who have joined us to give voice to Portuguese culture in Switzerland. Culture is also built in partnership.",
            institucional: "Institutional Partner",
            patrocinadores: "Sponsors",
            parceiroInstitucional: "Institutional Partner",
            celimar: "Exclusive Partner for Consulting and Insurance",
            ptPrint: "Print Partner",
            barniPost: "Media Partner · 21 October 2026 edition",
            tiers: { exclusiva: "Exclusive Sponsor", oficial: "Official Partner", premium: "Official Premium Sponsor", intermediario: "Co-Sponsor", apoiante: "Supporter" },
            tiersPlural: { exclusiva: "Exclusive Sponsor", oficial: "Official Partner", premium: "Premium Sponsors", intermediario: "Co-Sponsors", apoiante: "Supporters" },
        },
        quotas: {
            titulo: "FEES AND MEMBERSHIP",
            valor: "Fee: CHF 2 per month (CHF 24 per year).",
            isencao: "Founding members and honorary members are permanently exempt from the fee.",
            comoPagar: "How to pay the fee. While the association's bank account is being assigned, the fee can be paid in cash, directly at {famosa}. Keep the payment receipt and attach it to your membership application.",
            admissao: "Admission. The membership application is reviewed by the Executive Committee, which decides pursuant to art. 6 of the Statutes.",
            categoriasTitulo: "Membership categories (art. 5 of the Statutes)",
            fundadores: "Founders — permanently exempt from the fee",
            efetivos: "Full members — natural or legal persons admitted by the Executive Committee",
            honorarios: "Honorary members — outstanding services to the association, exempt from the fee",
            apoiantes: "Supporting members — support the association financially; no voting rights",
        },
        form: {
            titulo: "MEMBERSHIP APPLICATION",
            nome: "Full name", rua: "Street and number", cp: "Postal code", localidade: "City", pais: "Country",
            email: "E-mail", telefone: "Phone", telefoneOpc: "optional",
            categoria: "Desired category", catEfetivo: "Full member", catApoiante: "Supporting member",
            comprovativo: "Proof of payment of the fee",
            comprovativoNota: "PDF, JPG or PNG · max. 10 MB",
            escolherFicheiro: "Choose file",
            aceiteEstatutos: "I have read and accept the Statutes of the Fados à Mesa Association.",
            verEstatutos: "view Statutes",
            aceiteDados: "I authorize the processing of my personal data by the Fados à Mesa Association exclusively for the management of my membership, in accordance with the Federal Act on Data Protection (nFADP).",
            verNota: "view data protection note",
            enviar: "Submit Application", aEnviar: "Sending...",
            sucesso: "Application received. Your membership application will be reviewed by the Executive Committee. You will receive the answer by e-mail.",
            erroObrigatorio: "Required field",
            erroEmail: "Invalid e-mail",
            erroFicheiroTipo: "PDF, JPG or PNG only",
            erroFicheiroGrande: "The file exceeds 10 MB",
            erroGeral: "The application could not be sent. Please try again.",
        },
        estatutos: { titulo: "STATUTES", indice: "Index", descarregar: "Download Statutes (PDF)" },
        cartao: {
            titulo: "MEMBERSHIP CARD",
            categoriaEfetivo: "Full Member", categoriaApoiante: "Supporting Member",
            numero: "Member No.", desde: "Member since", valido: "Valid card",
            guardar: "Save Image", partilhar: "Share",
            nota: "Show this card at Associação Fados à Mesa events. Save the image to your phone or add this page to your home screen.",
            invalidoTitulo: "Invalid card",
            invalidoTexto: "This membership card is not valid or has been revoked. If in doubt, contact us through the Contact page.",
            aCarregar: "Checking the card…",
        },
        protecao: {
            titulo: "DATA PROTECTION",
            texto: "The Fados à Mesa Association processes the personal data of its members and applicants exclusively for the management of memberships and the association's activities, in compliance with the Federal Act on Data Protection (nFADP) and art. 27 of the Statutes. Data is never shared with third parties for commercial purposes. To access, correct or delete your data, contact produktion@fadosamesa.ch.",
        },
    },
    faq: {
        titulo: "Frequently Asked Questions",
        items: [
            { q: "Are drinks included in the ticket?", a: "The ticket includes a welcome port wine, starters, soup, main course, dessert and one coffee per person. Drinks and digestifs are not included." },
            { q: "Do I have to confirm my main course?", a: "Yes. Confirm your attendance and main course choice (fish or meat) by 1 November 2026 at fadosamesa.ch/confirmar." },
            { q: "Where do I buy tickets?", a: "At the official ticket office at fadosamesa.ch/bilhetes (Eventim Light / Ticket Corner). The event is exclusive and seats are limited." },
            { q: "How do I get to Centro Papa Giovanni?", a: "Hübelistrasse 55, 6020 Emmenbrücke — a 10-minute walk from Emmenbrücke Gersag station, with free parking nearby. Full details at fadosamesa.ch/local." },
        ],
    },
    experiencia: {
        tabs: { menu: "Event Menu", cultura: "Culture & Tradition", gastro: "Gastronomy & Wines", bar: "Bar" },
        bar: {
            nome: "A Famosa — Café & Sabores",
            cargoA: "Operation and service by",
            cargoB: "Pastelaria Famosa de Emmenbrücke",
            horarioTitulo: "Opening Hours",
            blocos: [
                { horas: "17H00 – 18H30", estado: "Open", nota: "Reception and Porto de Honra (welcome drink), until the dinner starters are served." },
                { horas: "18H30 – 23H30", estado: "Closed", nota: "Throughout the event." },
                { horas: "23H30 – 01H00", estado: "Reopened", nota: "Continuously until the venue closes." },
            ],
            regra: "The exclusivity rule and payment at the time of purchase remain in place.",
        },
        tituloA: "A ",
        tituloGold: "Portuguese",
        tituloB: " night,",
        tituloC: "served at the table.",
        p1: "Fados à Mesa is a dinner-show that brings together the best of two heritages: Portuguese gastronomy and Fado. Between each course, the Portuguese guitar and the fadista's voice fill the room, as in Lisbon's fado houses — but here, in Switzerland.",
        p2: "An entire night planned to the last detail: the table set, the candles lit, the wine served and the sacred silence when the fado begins.",
        menuLabel: "Official menu of the 1st edition",
        menuOficial: {
            bebidasTitulo: "Drinks are extra.",
            bebidasTexto: "They are not included in the ticket price.",
            entradas: "Starters",
            sopa: "Soup",
            sopaValor: "Caldo Verde",
            sopaTrad: "traditional Portuguese kale soup",
            prato: "Main Course",
            peixeLabel: "Option 1 — Fish",
            peixeValor: "Lombo de Bacalhau Assado no Forno com Batata a Murro",
            peixeTrad: "oven-roasted cod loin with punched potatoes",
            carneLabel: "Option 2 — Meat",
            carneValor: "Lombo de Porco com Batata Assada e Arroz",
            carneTrad: "roasted pork loin with roasted potatoes and rice",
            acompanhamento: "Both served with lettuce and tomato salad.",
            sobremesa: "Dessert",
            sobremesaNota: "One of two options of your choice",
            sobremesaOpcoes: "Homemade Pudding · Fruit Salad",
            final: "To Finish",
            finalValor: "Coffee",
            notaBilhetes: "Tickets purchased in the same booking guarantee seats at the same table, whenever possible.",
            notaSilencio: "To preserve the magic of live Fado, we kindly ask you to enter or leave the room only during the intervals.",
            notaEstacionamento: "Free parking near the Centro Papa Giovanni (not part of the venue; subject to availability).",
            notaRececao: "On arrival, please follow the directions of our reception team.",
            fecho: "We look forward to welcoming you for an unforgettable evening of Portuguese culture, gastronomy and the timeless tradition of Fado.",
        },
        zoomHint: "Tap the menu to zoom in",
        importante: "Important",
        notaA: "Each guest must confirm their attendance and choice of main course (fish or meat) by ",
        notaB: "Each guest must confirm their attendance and choice of main course by ",
        prazoData: "1 November 2026",
        confirmar: "Confirm Your Main Course",
        culturaTitulo: "THE NIGHT, MOMENT BY MOMENT",
        lineupTitulo: "Night Line Up",
        lineup: [
            { hora: "17h00", momento: "Guest arrival (until 5:30 pm)" },
            { hora: "17h00", momento: "Bar open (until 6:30 pm)", link: true },
            { hora: "17h30", momento: "Welcome Port Wine" },
            { hora: "18h30", momento: "Starters and drinks served at the table" },
            { hora: "19h00", momento: "First Fado performance" },
            { hora: "19h30", momento: "Soup" },
            { hora: "20h30", momento: "Second Fado moment" },
            { hora: "21h00", momento: "Main course" },
            { hora: "21h45", momento: "Third Fado moment" },
            { hora: "22h30", momento: "Dessert and coffee" },
            { hora: "22h30", momento: "The kitchen closes" },
            { hora: "23h00", momento: "Last fado of the night" },
            { hora: "23h45", momento: "Hall closes — bar service only, until 1:00 am (space closes)", link: true },
            { hora: "01h30", momento: "Centro Papa Giovanni closes" },
        ],
        lineupLink: "See bar opening hours",
        lineupNota: "Indicative schedule for the 1st edition — subject to confirmation.",
        etiquetaTitulo: "When the Fado is Sung",
        etiquetaTexto: "«Silence, for the fado is about to be sung.» The Portuguese way: when the guitar begins, the room falls silent — we listen with respect, feel in silence and applaud at the end. That's how it is in Lisbon, and that's how it will be at our table.",
        bilheteTitulo: "Your Ticket Includes",
        incluido: [
            "Welcome port wine on arrival",
            "Starters",
            "Soup",
            "Main course",
            "Dessert",
            "1 coffee per person",
        ],
        bebidas: "Drinks and digestifs are not included.",
        exclusivo: "Exclusive event — limited seats",
        gastroTitulo: "GASTRONOMY AND WINES",
        gastroCardTitulo: "Portuguese Gastronomy",
        gastroP1: "Our dishes are born from Portuguese products, chosen with the care of those who cook for family: the olive oil, the codfish, the sausages and the sweets that cross borders to reach your table just as they do in Portugal.",
        gastroP2: "Those who prepare each dish will be introduced soon — our kitchen is being chosen with the same care with which a guitar is tuned.",
        vinhosCardTitulo: "Portuguese Wines",
        vinhosP1: "A selection of wines from Portugal's finest regions — from Douro to Alentejo, from Dão to the green wines of Minho — designed to accompany every moment of the dinner and every fado of the night.",
        vinhosP2: "The wine list for the 1st edition will be revealed soon.",
    },
    equipa: {
        titulo: "OUR TEAM",
        tabs: { producao: "Production", staff: "Staff" },
        producaoTitulo: "Production Team",
        staffTitulo: "Staff — Kitchen, Floor & Bar",
        cozinhaTitulo: "Kitchen",
        salaTitulo: "Floor",
        barTitulo: "Bar",
        apoioTitulo: "Kitchen & Staff Team",
        producao: [
            {
                id: "paula-angelino", nome: "Paula Angelino", papel: "Executive Director — Artistic & Creative",
                texto: "Responsible for the artistic and creative vision of Fados à Mesa, she leads the project's identity, communication and production. Her goal is to promote Portuguese culture through authentic experiences that bring together music, gastronomy and tradition.",
            },
            {
                id: "paula-silva", nome: "Paula Silva", papel: "Logistics & Staff Director",
                texto: "Responsible for operational organisation and team coordination, she ensures every detail is rigorously planned and every event runs with quality and Portuguese hospitality.",
            },
            {
                id: "paulo-nunes", nome: "Paulo Nunes", papel: "Technical Director & Head of Venue Safety",
                texto: "Responsible for technical coordination and venue safety, he ensures every event runs with excellence, professionalism and complete confidence.",
            },
        ],
        cozinha: [
            {
                id: "fernando-rocha", nome: "Fernando Rocha", papel: "Head Chef",
                texto: "Responsible for creating and executing the menus, he ensures the quality, authenticity and presentation of every dish, valuing the finest ingredients and the tradition of Portuguese gastronomy.",
            },
            {
                id: "cristina-moita", nome: "Cristina Moita", papel: "Sous Chef",
                texto: "Responsible for supporting kitchen management and coordinating the team, she ensures the organisation, rigour and smooth running of every area, helping every detail reach the table with excellence.",
            },
        ],
        apoio: ["Cátia Ambrai", "Paulo", "Márcia Pinheiro"],
        sala: {
            id: "sergio-rego", nome: "Sérgio Rêgo", papel: "Head of Front of House",
            texto: "Coming directly from Lisbon, he works daily with the artists we present, ensuring attentive, discreet and excellent front-of-house service, so that every night is an unforgettable experience.",
        },
        salaApoio: { nome: "Rui Borges", papel: "Front of House Support" },
        barMembro: { nome: "Rui Borges", papel: "Pastelaria Famosa de Emmenbrücke" },
    },
    missao: {
        label: "The Mission",
        tituloA: "BRINGING ",
        tituloGold: "PORTUGUESE CULTURE",
        tituloB: " TO SWITZERLAND",
        subtitulo: "The night when Portugal invites Switzerland to sit at our table, honouring a friendship built over generations between the Portuguese people and the country that welcomed them.",
        capitulos: [
            {
                titulo: "The Origin",
                paragrafos: [
                    "Fados à Mesa was born from the desire to present Fado in its most authentic form, honouring the tradition of an artistic expression recognised by UNESCO as Intangible Cultural Heritage of Humanity.",
                    "More than a musical genre, Fado is a way of preserving memory, conveying emotions and telling the story of a people. It is a living heritage that crosses generations and continues to bring people together through poetry, music and Portuguese cultural identity.",
                ],
            },
            {
                titulo: "More Than a Concert",
                paragrafos: [
                    "That is why a night of Fado is not lived like a conventional concert. It is lived in an intimate atmosphere, where the closeness between artists and audience creates a deeply human experience. Every performance is listened to with respect, every word is valued and every silence is part of the music.",
                ],
            },
            {
                titulo: "Culture Deserves Time",
                paragrafos: [
                    "At Fados à Mesa, we believe that culture deserves time. It deserves attention. It deserves a space where heritage can be lived with authenticity, dignity and elegance.",
                    "The event was carefully designed to provide a cultural experience of the highest quality, where Portuguese tradition is presented in a contemporary, welcoming way, faithful to the international recognition Fado has earned.",
                ],
            },
            {
                titulo: "Portugal That Travels",
                paragrafos: [
                    "When distance makes returning to Portugal difficult, it is Portugal that travels to those who miss it. Fados à Mesa is also born of that purpose: to recreate, for one night, an atmosphere where memory, identity and the feeling of belonging come alive again through Portuguese music, tradition and culture.",
                ],
            },
            {
                titulo: "An Invitation to Switzerland",
                paragrafos: [
                    "But this project goes beyond the Portuguese community. It is also a gesture of friendship and sharing. It is Portugal inviting Switzerland to sit at our table. An invitation to discover a culture recognised worldwide, not only for the beauty of its music, but also for the authenticity, hospitality and richness of its heritage.",
                    "More than a dinner show, Fados à Mesa aims to establish itself as a meeting place between cultures, where Portuguese, Swiss and visitors from different backgrounds share the same table, listen to the same stories and discover that culture is a universal language capable of bringing people closer.",
                ],
            },
        ],
        valores: [
            { n: "I", title: "Culture", text: "Bringing Fado — humanity's intangible heritage — to new audiences." },
            { n: "II", title: "Table", text: "Sharing the gastronomy and wines that tell Portugal's story." },
            { n: "III", title: "Encounter", text: "Creating in Switzerland a meeting point between cultures, around the table." },
        ],
        fechoA: "In a time when so many experiences are lived in a hurry, Fado invites us to do precisely the opposite: to stop, to listen and to feel.",
        fechoB: "Because there are moments when the greatest sign of respect is not applause. It is silence.",
        fechoFinal: "Silence... Fado is about to be sung.",
    },
    contacto: {
        titulo: "CONTACT US",
        intro: "For anything related to Fados à Mesa, write to us here — we'll be happy to reply.",
        nome: "Name",
        nomePh: "Your name",
        email: "Email",
        emailPh: "youremail@example.com",
        assunto: "Subject",
        assuntos: [
            "Group bookings",
            "Partnerships and sponsorships",
            "Press and media",
            "Questions about the 1st edition",
            "Other subject",
        ],
        mensagem: "Message",
        mensagemPh: "Write your message...",
        enviar: "Send Message",
        aEnviar: "Sending...",
        erroGenerico: "The message could not be sent. Please try again.",
        sucessoTitulo: "Message sent.",
        sucessoTexto: "Thank you, {nome}. We've received your message and will reply soon.",
        fecho: "A Portuguese night, most certainly.",
    },
    local: {
        label: "Where the event takes place",
        titulo: "HOW TO GET HERE",
        intro: "All the practical information about the venue and how to get to Emmenbrücke — by public transport, car, Uber/taxi or bicycle.",
        morada: "Hübelistrasse 55, 6020 Emmenbrücke, Switzerland — 47.0706° N, 8.2849° E",
        moradaCurta: "Hübelistrasse 55, 6020 Emmenbrücke",
        comoChegar: "HOW TO GET HERE",
        cards: [
            {
                id: "transportes",
                title: "By Public Transport",
                text: "Emmenbrücke Gersag station is about a 10-minute walk away and is served by regional trains and buses 41, 42, 43 and 44. From Lucerne, VBL line 2 connects to the centre of Emmenbrücke; the N2 night bus links back to Lucerne.",
            },
            {
                id: "carro",
                title: "By Car",
                text: "5 minutes from the A2 motorway (Emmen Nord exit). Free Häger car park right across, limited to spaces marked «Häger» — see full details below.",
            },
            {
                id: "uber",
                title: "By Uber or Taxi",
                text: "Uber operates in Lucerne and the surrounding area: a ride from central Lucerne takes about 10 minutes.",
            },
            {
                id: "bicicleta",
                title: "By Bicycle",
                text: "Emmen is just a few minutes by bicycle from Lucerne, via cycle paths. Bicycle parking is available on site.",
            },
        ],
        mapsCta: "Open in Google Maps",
        mapsTexto: "Point your camera at the code or tap here — the exact location and nearest car parks are one touch away.",
        barTitulo: "Bar at the Venue",
        barTexto: "Open 17:00–18:30 and 23:30–01:00. Run by Pastelaria Famosa de Emmenbrücke — payment at the time of purchase.",
        estacionamentoHager: {
            titulo: "Free Parking — Häger",
            intro: "The closest car park to the event is the Häger car park, right across from Centro Papa Giovanni — free of charge, but limited to the capacity of the site.",
            pontos: [
                "Only the spaces marked «Häger» are made available to event guests.",
                "This information is provided for guidance only: we accept no responsibility for availability. There is no need to pay for parking.",
                "If the car park is full, please look nearby — there are several parking options in the area, some free and some paid.",
            ],
            mapsCta: "View car park on Google Maps",
        },
        fecho: "Getting here is easy. The hard part will be leaving.",
    },
    noticias: {
        label: "Press room",
        titulo: "NEWS",
        intro: "Welcome to the official Fados à Mesa News page. Here you will find the latest official announcements from Fados à Mesa, together with carefully selected news about the artists participating in our event. Our goal is to keep visitors informed through reliable and official sources while highlighting the artists who make this project possible. This page is updated regularly whenever new official information becomes available.",
        socialTitulo: "OUR LATEST POST",
        socialTituloMulti: "OUR LATEST POSTS",
        socialVer: "View Post",
        socialSeguir: "Follow Us",
        socialBio: "Fados à Mesa is now on Instagram — follow us for official announcements, the artists and behind-the-scenes moments.",
        verTodas: "View all news",
        ultimasTitulo: "LATEST NEWS",
        filtros: { todas: "All", projeto: "Fados à Mesa" },
        pesquisaPh: "Search news by keyword...",
        lerMais: "Read More",
        carregarMais: "Load More",
        aCarregar: "Loading...",
        semResultados: "No news found. Try another artist or keyword.",
        fonte: "Source",
        ctaTitulo: "Experience Fado Live",
        ctaReservar: "Reserve Your Seat",
    },
    patrocinadoresPage: {
        titulo: "OFFICIAL SPONSORS",
        texto: "The partners who make this night possible — thank you for believing in Portuguese culture in Switzerland.",
    },
    confirmacao: {
        label: "1st Edition · 14 November 2026",
        titulo: "CONFIRM YOUR ATTENDANCE",
        introA: "Confirm your attendance and choose your main course by ",
        prazoData: "1 November 2026",
        nome: "Full name",
        nomePh: "Your name",
        email: "Email",
        emailPh: "youremail@example.com",
        bilhete: "Ticket number (Ticket Corner)",
        bilhetePh: "E.g.: TC-123456789",
        escolhePrato: "Choose your main course",
        opcoes: [
            { id: "peixe", title: "Option 1 — Fish", desc: "Roast cod steak with punched potatoes and salad" },
            { id: "carne", title: "Option 2 — Meat", desc: "Roast pork loin with punched potatoes and salad" },
        ],
        submit: "Confirm Attendance",
        aRegistar: "Registering...",
        erroGenerico: "We couldn't register your confirmation. Please try again.",
        sucessoTitulo: "Attendance confirmed.",
        sucessoTexto: "Thank you, {nome}. Your choice ({prato}) has been registered. See you soon — on 14 November, at the table.",
        peixe: "fish",
        carne: "meat",
    },
    vantagens: {
        label: "Members",
        titulo: "MEMBER BENEFITS AND PARTNERSHIPS",
        intro: "Being a Fados à Mesa member costs CHF 2 per month (CHF 24 per year) and gives access to discounts in several places, in Portugal and Switzerland — starting with the 1st edition.",
        prova: "To use the partnerships, simply show your Digital Member Card (with QR code) or give your member number.",
        bilhetesTitulo: "1st Edition Tickets — 14 November 2026",
        bilhetesIntro: "Immediate discount on physical tickets purchased at Pastelaria Famosa, Emmenbrücke (cash, Twint or bank transfer).",
        colBilhete: "Ticket",
        colAte: "Until 31.10.2026",
        colDepois: "From 01.11.2026",
        linhas: [
            ["Adult, regular price", "CHF 119.90", "CHF 129.90"],
            ["Member, 1st adult ticket (− CHF 20)", "CHF 99.90", "CHF 109.90"],
            ["Adult purchased together with a member (− CHF 10)", "CHF 109.90", "CHF 119.90"],
            ["Child (6–15 years)", "CHF 65.00", "CHF 65.00"],
            ["Child purchased together with a member (− CHF 5)", "CHF 60.00", "CHF 60.00"],
        ],
        bilhetesNota: "Member discounts apply only to tickets purchased together with the member in the same transaction. The member number must be written on all tickets for internal registration.",
        fisicoTitulo: "Why physical tickets only?",
        fisicoTexto: "For project-management reasons, in this 1st edition member-discounted tickets are only available physically at Pastelaria Famosa. We intend to resolve this in a future edition and extend the discount to online purchases as well.",
        protocolosTitulo: "Partner Agreements",
        srVinhoTitulo: "Sr. Vinho — Traditional Restaurant",
        srVinhoTag: "Official Partner",
        srVinhoTexto: "All Fados à Mesa members now receive a 10% discount on cash payment of the final dinner bill at Sr. Vinho restaurant, plus a complimentary digestif.",
        srVinhoCta: "See the Sr. Vinho menu",
        famosaTitulo: "Pastelaria Famosa — Emmenbrücke",
        famosaTag: "Exclusive Sponsor",
        famosaTexto: "Official point of sale for physical member-discounted tickets for the 1st edition. Payment in cash, Twint or bank transfer.",
        cr7Titulo: "CR7 Helder — Limousine Transport",
        cr7Tag: "Official Premium Sponsor",
        cr7Texto: "With the code CR7, members get 10% off all Vachoux limousines (Helder Pacheco). Offer limited to the City of Geneva area, on 45-minute rides, with limousines for 12 to 16 people maximum.",
        cr7Codigo: "Code: CR7",
        cr7Cta: "Book at vachoux.com",
        emBreve: "More partnerships coming soon in Portugal and Switzerland. Members will be informed by e-mail.",
        ctaTitulo: "Not a member yet?",
        ctaTexto: "Simple online registration for CHF 24/year.",
        cta: "Become a member",
    },
    bilhetes: {
        precosTitulo: "Ticket Prices",
        precosStandard: "Standard",
        precosEarlyBird: "Early Bird",
        precosNormal: "Regular Price",
        precosCrianca: "Child (6–15 years)",
        precosCriancaNota: "Dinner with water and one complimentary house juice · Porto de Honra not included",
        socioLink: "Members: CHF 20 off the 1st ticket — see member benefits",
        precosNota: "Drinks not included · Limited seats · Dress code: smart dinner attire (not a gala, but almost)",
        titulo: "TICKET OFFICE",
        data: "14 November 2026 · Centro Papa Giovanni, Emmenbrücke",
        exclusivo: "Exclusive event · Limited seats",
        confirmarReserva: "Confirm Reservation",
        nota: "Official Eventim ticket office. After your purchase, confirm your attendance and meal choice at ",
    },
    ticketcorner: { label: "OFFICIAL SALES PARTNER" },
    privacidade: {
        label: "Fados à Mesa",
        titulo: "PRIVACY POLICY",
        seccoes: [
            {
                title: "1. Data controller",
                text: "The controller of personal data on this website is the Associação Fados à Mesa (hereinafter 'we'), UID CHE-306.330.271, Gerliswilstrasse 46, 6020 Emmenbrücke, Switzerland. For any question related to data protection, contact us through the Contact page.",
            },
            {
                title: "2. Legal framework",
                text: "The processing of personal data is carried out in accordance with the Swiss Federal Act on Data Protection (nFADP/revDSG, in force since 1 September 2023) and other applicable Swiss legislation.",
            },
            {
                title: "3. Data we collect",
                text: "At this stage, the website does not collect personal data through forms. When you contact us by email, we process your address and the content of the message only to respond to your request. Booking or ticket purchase data will be processed in the future through the Ticket Corner platform, under that platform's privacy policy.",
            },
            {
                title: "4. Cookies and analytics tools",
                text: "This website does not currently use tracking cookies or third-party analytics tools. Should these be introduced, this policy will be updated accordingly.",
            },
            {
                title: "5. Your rights",
                text: "Under Swiss law, you have the right to request information about your personal data, as well as its rectification or deletion. To exercise these rights, contact us through the Contact page.",
            },
            {
                title: "6. Changes",
                text: "We reserve the right to update this policy at any time. The version in force is the one published on this page. Last updated: September 2026.",
            },
        ],
    },
    termos: {
        label: "Fados à Mesa",
        titulo: "TERMS & CONDITIONS",
        seccoes: [
            {
                title: "1. Purpose",
                text: "These Terms & Conditions govern the use of the Fados à Mesa website and participation in the event. By using this website, you fully accept these conditions.",
            },
            {
                title: "2. Intellectual property",
                text: "The concept, the name «Fados à Mesa», the logo, the texts, the photographs, the videos, the design and all contents of this website are the exclusive property of the event organization and are protected by the Swiss Federal Act on Copyright and Related Rights (CopA/URG) and by applicable international conventions. The reproduction, copying, imitation, distribution or use, in whole or in part, of the concept, the brand, the texts, the images or any distinctive element of the project is expressly prohibited without prior written authorization from the organization. Any violation will be subject to legal action under Swiss law.",
            },
            {
                title: "3. Tickets and reservations",
                text: "Ticket sales will be carried out through the Ticket Corner platform, and that platform's terms and conditions apply. The event has limited capacity; a reservation is only valid after payment confirmation.",
            },
            {
                title: "4. Programme and changes",
                text: "The organization reserves the right to adjust the programme, schedules, menu and cast for reasons of force majeure, always guaranteeing the quality of the announced experience.",
            },
            {
                title: "5. Liability",
                text: "The organization is not responsible for damages arising from third-party information, unrelated technical failures or improper use of the website. The consumption of alcoholic beverages is reserved for adults, under Swiss law.",
            },
            {
                title: "6. Applicable law and jurisdiction",
                text: "These Terms are governed by Swiss law. For any dispute, the courts at the organization's domicile in Switzerland have jurisdiction. Last updated: September 2026.",
            },
        ],
    },
    artistPage: {
        naoEncontrado: "Artist not found.",
        imprensa: "Press & Highlights",
        emPalco: "On stage",
        oQueA: "What ",
        oQueGold: "awaits",
        oQueB: " you",
    },
    artists: {
        "rafael-pacheco": {
            role: "Portuguese Guitar",
            bio: "Born in Portimão (2000), he began at the age of 11 at the Boa Esperança fado school and trained with the renowned Portuguese guitar player Antunes, the Prince.\n\nWinner of the Ageas New Talents Award at Casa da Música (2023), he is a resident musician at emblematic fado houses, from Viseu to Lisbon.",
        },
        "ginestal-martins": {
            role: "Viola de Fado",
            bio: "A fado viola player on the Lisbon circuit, he is the musical foundation of countless nights — the viola that sensitively supports every voice.\n\nHe accompanies fadistas in fado houses and at EGEAC's Visitas Cantadas, through Lisbon's historic neighbourhoods, alongside guitarists such as Rafael Pacheco. He also performs as a fadista.",
        },
        "catia-garcia": {
            role: "Fadista",
            bio: "A fadista of soul and tradition, she brings to the stage the emotion of someone who lives fado from within. In 2021 she released the album «À Procura do Fado».\n\nA regular presence on television (RTP) and at Lisbon's fado nights, including the emblematic Sr. Vinho house.",
        },
        "daniel-pinto-coelho": {
            role: "Fadista",
            bio: "Born in Valongo, he first took the stage at the age of 4 and studied at the London Music School, before surrendering to fado in 2014.\n\nHe is part of the cast of the emblematic Sr. Vinho fado house in Lisbon, where his elegant voice is a regular presence.",
        },
        "madalena-gil": {
            role: "Fadista",
            bio: "Born in Almeirim, she charmed the country on The Voice Kids Portugal in 2021 with the fado «Ser Fadista».\n\nA young voice with an old soul, promising to take fado — and Portugal's name — even further.",
        },
    },
};
